import { createContext, useContext, useState, ReactNode } from 'react';

export type RoomStatus = 'available' | 'occupied';

export interface DormRoom {
  name: string;
  type: string;
  rent: number;
  deposit: number;
  total: number;
  status: RoomStatus;
}

export interface Dormitory {
  id: number;
  name: string;
  subtitle: string;
  address: string;
  access: string;
  gender: string;
  capacity: number;
  image: string;
  tags: string[];
  features: string[];
  note: string;
  rooms: DormRoom[];
  礼金: number;
  押金: number;
  color: string;
}

const initialDormitories: Dormitory[] = [
  {
    id: 10,
    name: '泉町 2F 宿舎',
    subtitle: '3DK・6床',
    address: '東京都板橋区泉町',
    access: '蓮沼駅 徒歩3分 ／ 三田線 7分',
    gender: '混合',
    capacity: 6,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/0bdef57e89993060e8a3850e4ffa678a.jpeg',
    tags: ['家電完備', '水道光熱費込み', 'Wi-Fi'],
    features: ['エアコン', '冷蔵庫', '洗濯機', 'Wi-Fi', '電子レンジ'],
    note: '水道光熱費込み（上限1万円）',
    rooms: [
      { name: '双人間1', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間2', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間3', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'teal',
  },
  {
    id: 11,
    name: '泉町 3F 宿舎',
    subtitle: '2DK・3床',
    address: '東京都板橋区泉町',
    access: '蓮沼駅 徒歩3分 ／ 三田線 7分',
    gender: '混合',
    capacity: 3,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/2a1f30e930aa6d173abdc3711c561bdf.jpeg',
    tags: ['家電完備', '水道光熱費込み', 'Wi-Fi'],
    features: ['エアコン', '冷蔵庫', '洗濯機', 'Wi-Fi', '電子レンジ'],
    note: '水道光熱費込み（上限1万円）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '単人間', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
    ],
    礼金: 0,
    押金: 4,
    color: 'sky',
  },
  {
    id: 12,
    name: '高島平 女生宿舎 403',
    subtitle: '3DK・4床',
    address: '東京都板橋区高島平',
    access: '高島平駅 徒歩4分 ／ 三田線 西巣鴨まで17分',
    gender: '女性専用',
    capacity: 4,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/c13c4f63563339b1da6b8278e7dc7204.jpeg',
    tags: ['女性専用', '水道光熱費全包', 'Wi-Fi', '家電完備'],
    features: ['エアコン', '冷蔵庫', '洗濯機', '熱水器', '電飯鍋', '電子レンジ', 'Wi-Fi'],
    note: '水道光熱費・ネット費全包',
    rooms: [
      { name: '双人間（和室2）', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間（和室3）', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'rose',
  },
  {
    id: 13,
    name: '志村三丁目 2号宿舎 306室',
    subtitle: '3DK・4床',
    address: '東京都板橋区志村三丁目',
    access: '志村三丁目駅 徒歩4分 ／ 三田線 巣鴨・上野方面',
    gender: '混合',
    capacity: 4,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/878e1f4f1602a53dea38243fcd62ab06.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '二段ベッド'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '掃除機', '電飯鍋', '電子レンジ', 'Wi-Fi'],
    note: '水道光熱費全包（上限1万円）・礼金5万・押金4万',
    rooms: [
      { name: '双人間1', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間2', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
      { name: '単人間', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'amber',
  },
  {
    id: 14,
    name: '西高島平 1号宿舎 三園コーポ201',
    subtitle: '2空一厅・3床',
    address: '東京都板橋区西高島平',
    access: '西高島平駅 徒歩7分 ／ 三田線 西巣鴨駅まで20分・徒歩5分で学校',
    gender: '混合',
    capacity: 3,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/54c85b0bbd33083a2aa2eae15e834966.jpeg',
    tags: ['家電完備', '水道光熱費全包', '移動Wi-Fi', '浴室乾湿分離'],
    features: ['エアコン', '冷蔵庫', '洗濯機', '熱水器', '電気ケトル', '電飯鍋', '電子レンジ', '掃除機', '移動Wi-Fi'],
    note: '単人間7万円／双人間5万円（月額）・水道光熱費全包（上限1万円）・礼金5万・押金4万',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '単人間', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'violet',
  },
  {
    id: 15,
    name: '西台 3号宿舎 第9棟 401室',
    subtitle: '2DK・4床',
    address: '東京都板橋区西台',
    access: '西台駅 徒歩6分 ／ 三田線 西巣鴨駅まで15分・徒歩3分で学校',
    gender: '混合',
    capacity: 4,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/500b54c8b5a61871c0f2b73b25d26b4a.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離'],
    features: ['エアコン', '冷蔵庫', '洗濯機', '熱水器', '電気ケトル', '掃除機', '電飯鍋', '電子レンジ', 'Wi-Fi'],
    note: '水道光熱費全包（上限1万円）・礼金5万・押金4万',
    rooms: [
      { name: '北卧双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '南卧双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'emerald',
  },
  {
    id: 16,
    name: '蓮根 2号宿舎 305室',
    subtitle: '2DK・3床',
    address: '東京都板橋区蓮根',
    access: '蓮根駅 徒歩8分 ／ 三田線12分で西巣鴨・徒歩5分で学校',
    gender: '混合',
    capacity: 3,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/199811756f3b0071107654bd92579224.jpeg',
    tags: ['家電完備', '水道光熱費全包', '移動Wi-Fi', '浴室乾湿分離'],
    features: ['エアコン', '冷蔵庫', '洗濯機', '熱水器', '電気ケトル', '電飯鍋', '電子レンジ', '掃除機', '移動Wi-Fi'],
    note: '水道光熱費全包（上限1万円）・礼金5万・押金4万',
    rooms: [
      { name: '双人間（和室6帖）', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '単人間（和室4.5帖）', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'indigo',
  },
  {
    id: 17,
    name: '板橋区役所前 男生宿舎',
    subtitle: '3室一厅・7床',
    address: '東京都板橋区',
    access: '板橋区役所前駅 徒歩7分 ／ 三田線4分で西巣鴨・徒歩3分で学校',
    gender: '男性専用',
    capacity: 7,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/7baeb61b429017abed99b7a4b45cc600.jpeg',
    tags: ['男性専用', '家電完備', '水道光熱費全包', 'Wi-Fi', '二段ベッド', '学習区あり'],
    features: ['エアコン', '冷蔵庫', '洗濯機', '熱水器', '電気ケトル', '掃除機', '電飯鍋', '電子レンジ', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万',
    rooms: [
      { name: 'A 双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: 'B 双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: 'C 双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '四人間', type: '四人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'orange',
  },
  {
    id: 18,
    name: '新高島平 4号宿舎 401室',
    subtitle: '3DK・3床',
    address: '東京都板橋区新高島平',
    access: '新高島平駅 徒歩9分 ／ 三田線18分で西巣鴨・徒歩3分で学校',
    gender: '混合',
    capacity: 3,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/277bf890837cd86d6ec2ca1634f59b3e.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '電気ケトル', '掃除機', '電飯鍋', '電子レンジ', 'Wi-Fi'],
    note: '双人間30万/人（6ヶ月）・水道光熱費全包・礼金5万・押金4万・清掃費4万',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '単人間', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'pink',
  },
  {
    id: 19,
    name: '志村三丁目 3号宿舎 406室',
    subtitle: '3DK・3床',
    address: '東京都板橋区志村三丁目',
    access: '志村三丁目駅 徒歩4分 ／ 三田線で巣鴨・上野方面・山手線で上野駅徒歩8分で学校',
    gender: '混合',
    capacity: 3,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/af9a80433ba5330688adbfb2b85f3599.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '単人間42万/人・双人間30万/人（6ヶ月）・水道光熱費全包（上限1万円）・礼金5万・押金4万',
    rooms: [
      { name: '単人間', type: '単人間', rent: 42, deposit: 4, total: 55, status: 'available' },
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'cyan',
  },
  {
    id: 20,
    name: '新高島平 3号宿舎 208室',
    subtitle: '2DK・2床',
    address: '東京都板橋区新高島平',
    access: '宿舎車站徒歩1分 ／ 三田線18分で巣鴨・山手線10分・徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/684dcfc6a0f17c7f9f881a13ba226efa.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'pink',
  },
  {
    id: 21,
    name: 'シャルム西台1号 宿舎301',
    subtitle: '2DK・2床',
    address: '東京都板橋区西台',
    access: '宿舎駅 徒歩1分 ／ 三田線15分で巣鴨・山手線10分で高田馬場・徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/ddc113cd7a48822e6f0dfdbd2e35b906.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'lime',
  },
  {
    id: 22,
    name: '新高島平 宿舎 604室',
    subtitle: '2室一厅・2床',
    address: '東京都板橋区新高島平',
    access: '宿舎車站 徒歩4分 ／ 三田線20分で巣鴨・山手線で高田馬場 徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/41a036700fd4d7b349cccf06ce6289ec.jpeg',
    tags: ['家電完備', '水道光熱費全包', '移動Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', '移動Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'cyan',
  },
  {
    id: 23,
    name: '志村三丁目 宿舎 2F',
    subtitle: '3室一厅・5床',
    address: '東京都板橋区蓮根',
    access: '蓮根駅 徒歩8分 ／ 三田線13分で西巣鴨・徒歩3分で学校',
    gender: '混合',
    capacity: 5,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/8a7683662e17a04f90cfdb2cbaf494e4.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間1', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間2', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間3（学姐在住）', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'emerald',
  },
  {
    id: 24,
    name: '新高島平 2号宿舎 ウィーンハイツ101',
    subtitle: '2室一厅・2床',
    address: '東京都板橋区高島平',
    access: '宿舎車站 徒歩4分 ／ 三田線18分で転山手線10分・徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/1ceb7ff51074fc39e3b53ee3573dd9e3.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'amber',
  },
  {
    id: 25,
    name: '蓮根 女生宿舎 戸建',
    subtitle: '3室一厅・6床',
    address: '東京都板橋区蓮根',
    access: '蓮根駅 徒歩2分 ／ 三田線13分で西巣鴨・徒歩3分で学校',
    gender: '女性専用',
    capacity: 6,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/b6090436a6b99f485818eb1ac78fea1d.jpeg',
    tags: ['女性専用', '家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '戸建'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間1', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間2', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
      { name: '双人間3（学姐在住）', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'occupied' },
    ],
    礼金: 5,
    押金: 4,
    color: 'rose',
  },
  {
    id: 26,
    name: 'シャルム西台 2号宿舎 303室',
    subtitle: '2室一厅・双人間',
    address: '東京都板橋区西台',
    access: '宿舎駅 徒歩1分 ／ 三田線15分で巣鴨・山手線10分・徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/bc43b7c847fc556d545bcbbd293f717e.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'sky',
  },
  {
    id: 27,
    name: '西台 4号宿舎 302室',
    subtitle: '2室一厅・双人間',
    address: '東京都板橋区西台',
    access: '宿舎駅 徒歩1分 ／ 三田線15分で巣鴨・山手線10分・徒歩3分で学校',
    gender: '混合',
    capacity: 2,
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/bc43b7c847fc556d545bcbbd293f717e.jpeg',
    tags: ['家電完備', '水道光熱費全包', 'Wi-Fi', '浴室乾湿分離', '厨房共用'],
    features: ['エアコン', '電冰箱', '洗濯機', '熱水器', '焼水壺', '吸塵器', '電飯鍋', '微波炉', 'Wi-Fi'],
    note: '水道光熱費全包・礼金5万・押金4万・清掃費4万（1回）',
    rooms: [
      { name: '双人間', type: '双人間', rent: 30, deposit: 4, total: 45, status: 'available' },
    ],
    礼金: 5,
    押金: 4,
    color: 'emerald',
  },
];

interface DormitoryContextValue {
  dormitories: Dormitory[];
  toggleRoomStatus: (dormId: number, roomName: string) => void;
  getAvailableCount: (dorm: Dormitory) => number;
  isFullyOccupied: (dorm: Dormitory) => boolean;
}

const DormitoryContext = createContext<DormitoryContextValue | null>(null);

export function DormitoryProvider({ children }: { children: ReactNode }) {
  const [dormitories, setDormitories] = useState<Dormitory[]>(initialDormitories);

  const toggleRoomStatus = (dormId: number, roomName: string) => {
    setDormitories((prev) =>
      prev.map((d) =>
        d.id === dormId
          ? {
              ...d,
              rooms: d.rooms.map((r) =>
                r.name === roomName
                  ? { ...r, status: r.status === 'available' ? 'occupied' : 'available' }
                  : r
              ),
            }
          : d
      )
    );
  };

  const getAvailableCount = (dorm: Dormitory) =>
    dorm.rooms.filter((r) => r.status === 'available').length;

  const isFullyOccupied = (dorm: Dormitory) => getAvailableCount(dorm) === 0;

  return (
    <DormitoryContext.Provider value={{ dormitories, toggleRoomStatus, getAvailableCount, isFullyOccupied }}>
      {children}
    </DormitoryContext.Provider>
  );
}

export function useDormitory() {
  const ctx = useContext(DormitoryContext);
  if (!ctx) throw new Error('useDormitory must be used within DormitoryProvider');
  return ctx;
}
